<template>
  <div></div>
</template>

<script>
import { AUTH_LOGOUT } from "@/store/modules/auth/auth.type";
import { NAV_ERROR } from "@/store/modules/navigation/nav.type";
import { USER_PERMISSION_SET } from "@/store/modules/user/user.type";

export default {
  name: "Logout",
  data() {
    return {};
  },
  created() {
    this.$store.dispatch(AUTH_LOGOUT).then(
      () => {
        this.$store.dispatch(NAV_ERROR);
        this.$store.dispatch(USER_PERMISSION_SET, []);
        this.$emit("logout");
        this.$router.push({ name: "login" });
      },
      errMsg => {
        this.$store.dispatch(NAV_ERROR);
        this.$store.dispatch(USER_PERMISSION_SET, []);
        this.$emit("logout");
        this.$router.push({ name: "login" });
      }
    );
  }
};
</script>



// WEBPACK FOOTER //
// src/views/login/Logout.vue